export function findMatchingRoute(pathname, allRoutes) {
    // Sort routes by specificity - more specific routes (longer paths, more segments) first
    const sortedRoutes = [...allRoutes].sort((a, b) => {
        // Count path segments and parameters for specificity
        const aSegments = a.path.split('/').length;
        const bSegments = b.path.split('/').length;
        const aParams = (a.path.match(/:/g) || []).length;
        const bParams = (b.path.match(/:/g) || []).length;

        // More segments = more specific
        if (aSegments !== bSegments) {
            return bSegments - aSegments;
        }

        // Fewer parameters = more specific (more literal segments)
        return aParams - bParams;
    });

    const foundRoute = sortedRoutes.find((route) => {
        if (route.path === pathname) {
            return true;
        }

        if (route.path.endsWith('/*')) {
            const basePath = route.path.slice(0, -2);
            const matches = pathname === basePath || pathname.startsWith(`${basePath}/`);
            return matches;
        }

        if (route.path.includes(':')) {
            const regexPattern = route.path
                .replace(/:[^/]+/g, '[^/]+')
                .replace(/\*/g, '.*')
                .replace(/\//g, '\\/');

            // For nested routes, allow additional path segments after the main path
            const nestedRegexPattern = `${regexPattern}(?:/.*)?`;
            const regex = new RegExp(`^${nestedRegexPattern}$`);
            const matches = regex.test(pathname);

            return matches;
        }

        const matches = pathname === route.path || pathname.startsWith(`${route.path}/`);

        return matches;
    });

    return foundRoute;
}

export function getRouteByPath(pathname, mainRoutes, signerRoutes) {
    const allRoutes = [...mainRoutes, ...signerRoutes];
    return findMatchingRoute(pathname, allRoutes);
}
